import oldApi, {
  IProgressEvent,
  IResponse,
  createApiWithNewBasePath as api,
} from "@api";
import { IPhoto } from "../Containers/PhotoBookRouter/Router";

export interface IPresignedUrlPayload {
  category?: string;
  file_extension: string;
  rawFile: File;
}
export interface IPresignedURLResponse {
  fileName: string;
  presignedUrl: string;
}

export const getPresignedUrlService = async (payload: IPresignedUrlPayload) => {
  try {
    const { data } = await api.get<
      typeof payload,
      { data: IPresignedURLResponse }
    >("photo_attachments/new", { category: "portfolio", ...payload });

    return data?.data;
  } catch (error) {
    throw error;
  }
};

export const uploadPhotoBookService = async (
  url: string,
  file: File,
  config: { onUploadProgress: (progressEvent: IProgressEvent) => void }
) => {
  try {
    return api.put<File, IResponse>(url, file, {
      headers: {
        "Content-Type": file?.type,
        Authorization: null,
      },
      onUploadProgress: config.onUploadProgress,
    });
  } catch (error) {
    throw error;
  }
};

export const attachUploadedPhotoToServiceProviderService = async ({
  filename,
  listworker_id,
}) => {
  const payload = {
    category: "portfolio",
    photo: filename,
    photo_attachable_id: listworker_id,
  };
  try {
    const result = await api.post<
      typeof payload,
      {
        data: { data: IPhoto };
      }
    >("photo_attachments", payload);
    return result?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getPortfolioPhotoAttachmentsService = async ({
  listworker_id,
  limit = 20,
  offset = 0,
}) => {
  try {
    const {
      data: { data },
    } = await oldApi.get<
      unknown,
      {
        data: { photos: IPhoto[]; count: number };
      }
    >(
      `public/portfolios/${listworker_id}/photo_attachments?limit=${limit}&offset=${offset}&sort_by=id&sort_order=desc`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const deletePhotoAttachmentService = async (
  photoAttachmentId: string | number
) => {
  try {
    return api.delete(`photo_attachments/${photoAttachmentId}`);
  } catch (error) {
    throw error;
  }
};
